import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Home from '../pages/home';
import HistoryList from '../components/Orders/OrdersHistoryList/OrderHistory';
import OrderHistoryDetails from '../components/Orders/OrderHistoryDetails/OrderHistoryDetails';
import CustomGoogleMap from '../components/GoogleMaps';
import Outlet from '../pages/outlet/index';
import Search from '../components/Search';
import Summary from '../pages/summary';
import Payment from '../pages/payment';
import Tracking from '../pages/tracking';
import Success from '../pages/success';
import UltraValue from '../pages/ultra-value';
import Promotion from '../pages/promotion';
import Favorite from '../pages/favorite';
import JoinMerchant from '../pages/join-merchant';
import Ufoodx from '../ufood-x/router'
import FreshchatFrame from '../components/LiveChat/FreshchatFrame';
import Restaurant from '../components/Restaurant';

const useRouter = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	const routes = [
		{
			exact: true,
			path: '/',
			component: Home,
		},
		{
			exact: true,
			path: '/search',
			component: Search,
		},
		{
			exact: true,
			path: '/google-map',
			component: CustomGoogleMap,
		},
		{
			exact: true,
			path: '/summary',
			component: Summary,
		},
		{
			exact: true,
			path: '/favourites',
			component: Favorite,
		},
		{
			exact: true,
			path: '/history/:orderType/:orderNumber',
			component: OrderHistoryDetails,
		},
		{
			exact: true,
			path: '/history/:orderType',
			component: HistoryList,
		},
		{
			exact: true,
			path: '/history',
			component: HistoryList,
		},
		{
			exact: true,
			path: '/payment',
			component: Payment,
		},
		{
			exact: true,
			path: '/outlet/:slug/:type',
			component: Outlet,
		},
		{
			exact: true,
			path: '/tracking',
			component: Tracking,
		},
		{
			exact: true,
			path: '/payment/success',
			component: Success,
		},
		{
			exact: true,
			path: '/ultra-value',
			component: UltraValue,
		},
		{
			exact: true,
			path: '/promotion',
			component: Promotion,
		},
		{
			exact: true,
			path: '/payment-partner',
			component: null,
		},
		{
			exact: true,
			path: '/join-merchant-ufood',
			component: JoinMerchant,
		},
    // {
		// 	exact: true,
		// 	path: '/freshchatframe',
		// 	component: FreshchatFrame,
    // },
    {
			exact: true,
			path: '/restaurant',
			component: Restaurant,
    },
    ...Ufoodx,
	];

	return {
		routes,
	};
};

export default useRouter;
